import { Route } from "react-router-dom";

import { STOCK_ROUTES } from "src/pages/stock/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { MoveStock } from "./MoveStock";
import { SingleYard } from "./SingleYard";
import { Yards } from "./Yards.page";

/** Route tree for the stock and yards module, mounted under `/yards` and `/MoveStock`. */
export const stockRoutes = (
  <>
    <Route path={STOCK_ROUTES.root} element={<ProtectedRoute component={Yards} />} />
    <Route path={STOCK_ROUTES.details} element={<ProtectedRoute component={SingleYard} />} />
    <Route path={STOCK_ROUTES.moveStock} element={<ProtectedRoute component={MoveStock} />} />
  </>
);
